/* =====================================================================
   RYNOR – cart drawer extras
   1) Low-stock pill + "Reserved for 15:00" timer   (snippets/rynor-cart-urgency.liquid)
   2) Shipping protection: pre-tick, untick, re-tick (snippets/rynor-cart-protection.liquid)
   3) "Learn more" pop-up
   4) Keeps the cart count bubble + free shipping bar from counting the protection line

   1) and 2) each have an on/off switch in Theme settings › Cart › Cart drawer extras.
   Switched off, Liquid doesn't render them and this file leaves them alone, except that
   protection still in a cart from before gets taken out, and the saved timer start is cleared.

   Nothing in assets/cart.js had to change: every time the theme re-draws the drawer
   (WAU.AjaxCart.updateView / initializeAjaxCart) a MutationObserver picks it up here.
   ===================================================================== */
(function () {
  'use strict';

  if (window.RynorCartExtras) return;

  var RESERVE_KEY = 'rynor:cart-reserve';
  var RESERVE_FRESH_MS = 6 * 60 * 60 * 1000; // a visit 6+ hours later gets a fresh timer
  var DECLINED_ATTR = '_shipping_protection';
  var MAX_AUTO_FAILS = 2;

  var routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  var busy = false;          // a protection request is in flight
  var autoFails = 0;         // failed auto-adds this page view
  var removeFails = 0;       // failed automatic removals this page view
  var tickTimer = null;
  var renderQueued = false;
  var modal = null;          // the open pop-up
  var modalOpener = null;
  var swallowEscKeyup = false;
  var declinedCleared = false; // "declined" already cleared for the cart that just emptied

  /* ------------------------------------------------------------------ */
  /* helpers                                                            */
  /* ------------------------------------------------------------------ */
  function qs(sel, scope) { return (scope || document).querySelector(sel); }
  function qsa(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }
  function isShown(el) { return !!(el && el.getClientRects().length); }

  function drawer() { return document.getElementById('slideout-ajax-cart'); }
  function drawerOpen() {
    var d = drawer();
    if (d) return d.classList.contains('slideout--active');
    var m = document.getElementById('modal-ajax-cart');
    return !!(m && isShown(m));
  }

  function cartConfig() {
    var el = document.getElementById('cart-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return null; }
  }

  /* Protection requests go through XMLHttpRequest on purpose: assets/rynor-pixels.js only
     watches fetch(), so ticking/unticking protection never reaches TikTok / Google / Snap as
     an add_to_cart or remove_from_cart event and your ad data stays about real products. */
  function postCart(path, body) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', routesRoot + path, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) resolve(xhr.responseText);
        else reject(new Error('Cart request failed (' + xhr.status + ')'));
      };
      xhr.onerror = function () { reject(new Error('Network error')); };
      xhr.send(JSON.stringify(body));
    });
  }

  /* Re-draw the drawer with the theme's own code (same path as the qty buttons) */
  function redrawCart() {
    var config = cartConfig();
    var W = window.WAU;
    if (!config || !W || !W.ThemeCart || !W.AjaxCart || typeof W.AjaxCart.updateView !== 'function') {
      return Promise.resolve();
    }
    return W.ThemeCart.getCart().then(function (cart) {
      W.AjaxCart.updateView(config, cart);
    });
  }

  /* What Liquid rendered for this version of the cart (see rynor-cart-protection.liquid) */
  function readMeta() {
    var el = qs('[data-rynor-cart-meta]');
    if (!el) return null;
    var meta = {
      visible: parseInt(el.getAttribute('data-visible-count'), 10) || 0,
      /* Theme settings › Cart switches (a missing attribute counts as on, like before) */
      enabled: el.getAttribute('data-protect-enabled') !== '0',
      urgency: el.getAttribute('data-urgency-enabled') !== '0',
      protectQty: parseInt(el.getAttribute('data-protect-qty'), 10) || 0,
      variant: el.getAttribute('data-protect-variant') || '',
      auto: el.getAttribute('data-protect-auto') === '1',
      declined: el.getAttribute('data-protect-declined') === '1'
    };
    /* cart.js empties the cart without re-drawing it (it only hides the form),
       so a hidden form next to a non-zero count means "now empty" */
    var form = el.closest('.js-cart-form');
    if (meta.visible > 0 && form && form.classList.contains('hide')) {
      meta.visible = 0;
      meta.protectQty = 0;
    }
    return meta;
  }

  /* ------------------------------------------------------------------ */
  /* 4) cart count bubble + free shipping bar                           */
  /* ------------------------------------------------------------------ */
  function syncCountAndFreeShipping(meta) {
    qsa('.js-cart-count').forEach(function (el) {
      var next = String(meta.visible);
      if (el.textContent !== next) el.textContent = next;
      el.classList.toggle('cart-empty', meta.visible < 1);
    });

    /* Liquid works out the bar (protection excluded, money in the shopper's currency);
       copy it into the bar that sits outside the re-drawn area */
    var source = qs('template[data-rynor-free-ship]');
    var bar = qs('.cart-shipping-countdown');
    if (!bar) return;
    /* v38: no fresh numbers yet (drawer not loaded) → the bar's own server-rendered numbers */
    var from = source || bar;
    var title = bar.querySelector('.cart-shipping-countdown__title');
    var fill = bar.querySelector('.cart-shipping-countdown__barFill');
    var html = source ? source.innerHTML.trim() : '';
    var progress = parseFloat(from.getAttribute('data-progress')) || 0;
    /* cart in another currency: Liquid can't convert the threshold, assets/rynor-i18n.js can */
    if (from.getAttribute('data-same-currency') === 'false' && window.RynorI18n) {
      var calc = window.RynorI18n.freeShipping(from);
      if (calc) { html = calc.html; progress = calc.progress; }
    } else if (!source) {
      return;
    }
    if (title && html && title.innerHTML.trim() !== html) title.innerHTML = html;
    if (fill) fill.style.width = progress + '%';
  }

  /* ------------------------------------------------------------------ */
  /* 1) reservation timer                                               */
  /* ------------------------------------------------------------------ */
  function readReserve() {
    try {
      var saved = JSON.parse(window.localStorage.getItem(RESERVE_KEY) || 'null');
      return saved && typeof saved.start === 'number' ? saved : null;
    } catch (e) { return null; }
  }
  function writeReserve(value) {
    try { window.localStorage.setItem(RESERVE_KEY, JSON.stringify(value)); } catch (e) {}
  }
  function clearReserve() {
    try { window.localStorage.removeItem(RESERVE_KEY); } catch (e) {}
  }
  function two(n) { return (n < 10 ? '0' : '') + n; }

  function tick() {
    var pills = qsa('[data-rynor-urgency]');
    if (!pills.length) { stopTicking(); return; }

    var now = Date.now();
    var saved = readReserve();

    pills.forEach(function (pill) {
      var total = (parseFloat(pill.getAttribute('data-minutes')) || 15) * 60000;

      /* the clock starts the first time the shopper actually sees it */
      if (isShown(pill) && (!saved || now - saved.start > RESERVE_FRESH_MS)) {
        saved = { start: now };
        writeReserve(saved);
      }

      var left = saved ? Math.max(0, saved.start + total - now) : total;
      var secs = Math.ceil(left / 1000);
      var label = two(Math.floor(secs / 60)) + ':' + two(secs % 60);

      qsa('[data-rynor-timer]', pill).forEach(function (el) {
        if (el.textContent !== label) el.textContent = label;
      });
      pill.classList.toggle('is-expired', !!saved && left <= 0);
    });
  }
  function startTicking() {
    tick();
    if (!tickTimer) tickTimer = window.setInterval(tick, 1000);
  }
  function stopTicking() {
    if (tickTimer) { window.clearInterval(tickTimer); tickTimer = null; }
  }

  /* ------------------------------------------------------------------ */
  /* 2) shipping protection                                             */
  /* ------------------------------------------------------------------ */
  function setRowsBusy(on) {
    qsa('[data-rynor-protect]').forEach(function (row) {
      row.classList.toggle('is-busy', on);
      if (on) row.setAttribute('aria-busy', 'true');
      else row.removeAttribute('aria-busy');
    });
  }

  /* qty 0/1 for the protection variant, plus (optionally) the declined flag – one request */
  function setProtection(variantId, qty, declined) {
    if (!variantId || busy) return Promise.resolve(false);
    var body = { updates: {} };
    body.updates[variantId] = qty;
    if (typeof declined === 'boolean') {
      body.attributes = {};
      body.attributes[DECLINED_ATTR] = declined ? 'declined' : '';
    }

    busy = true;
    setRowsBusy(true);

    return postCart('cart/update.js', body)
      .then(function () { busy = false; return redrawCart(); })
      .then(function () { return true; })
      .catch(function (err) {
        busy = false;
        setRowsBusy(false);
        if (window.console) console.warn('[rynor-cart-extras]', err && err.message);
        redrawCart(); /* show the cart as it really is */
        return false;
      });
  }

  /* Runs after every drawer re-draw and whenever the drawer opens */
  function syncProtection(meta) {
    if (!meta || !meta.variant || busy) return;

    var want = null;
    if (!meta.enabled) {
      if (meta.protectQty > 0) want = 0;            /* switched off: take it out of carts that still have it */
    } else if (meta.visible < 1) {
      if (meta.protectQty > 0) want = 0;            /* nothing left to protect */
    } else if (meta.protectQty > 1) {
      want = 1;                                      /* never more than one */
    } else if (meta.auto && meta.protectQty === 0 && autoFails < MAX_AUTO_FAILS && drawerOpen()) {
      want = 1;                                      /* pre-ticked: add it when the cart opens */
    }
    if (want === null) return;
    if (want === 0 && removeFails >= MAX_AUTO_FAILS) return;

    setProtection(meta.variant, want).then(function (ok) {
      if (ok) return;
      if (want === 1) autoFails++;
      else removeFails++;
    });
  }

  /* Unticking only counts for the cart it happened in: once that cart is empty, clear the flag
     so the next cart starts with protection ticked again (no re-draw needed, the cart is empty) */
  function resetDeclinedForNextCart(meta) {
    if (!meta.declined || declinedCleared || busy) return;
    declinedCleared = true;
    var body = { attributes: {} };
    body.attributes[DECLINED_ATTR] = '';
    postCart('cart/update.js', body).catch(function () { declinedCleared = false; });
  }

  function onToggle(input) {
    var meta = readMeta();
    if (!meta || !meta.variant || !meta.enabled) return;
    if (busy) { input.checked = !input.checked; return; }

    var on = input.checked;
    var row = input.closest('[data-rynor-protect]');
    if (row) row.classList.toggle('is-on', on);
    setProtection(meta.variant, on ? 1 : 0, !on);
    refreshModalCta();
  }

  /* ------------------------------------------------------------------ */
  /* 3) "Learn more" pop-up                                             */
  /* ------------------------------------------------------------------ */
  function placeModal() {
    if (!modal) return;
    var d = drawer();
    var rect = d && isShown(d) ? d.getBoundingClientRect() : null;
    if (rect && window.innerWidth >= 768 && rect.width > 0 && rect.width < window.innerWidth) {
      /* desktop: centre it over the cart drawer */
      modal.style.setProperty('--rynor-pmodal-x', Math.round(rect.left + rect.width / 2) + 'px');
      modal.style.setProperty('--rynor-pmodal-w', Math.round(Math.min(380, rect.width - 40)) + 'px');
    } else {
      modal.style.removeProperty('--rynor-pmodal-x');
      modal.style.removeProperty('--rynor-pmodal-w');
    }
  }

  function protectionTicked() {
    var input = qs('[data-rynor-protect-toggle]');
    if (input) return input.checked;
    var meta = readMeta();
    return !!(meta && meta.protectQty > 0);
  }

  function refreshModalCta() {
    if (!modal) return;
    var cta = modal.querySelector('[data-rynor-pmodal-cta]');
    if (!cta) return;
    var on = protectionTicked();
    cta.setAttribute('data-mode', on ? 'done' : 'add');
    cta.textContent = on ? cta.getAttribute('data-label-done') : cta.getAttribute('data-label-add');
  }

  function openModal(opener) {
    var row = opener.closest('[data-rynor-protect]');
    var template = row && row.querySelector('template[data-rynor-protect-dialog]');
    if (!template) return;

    closeModal(true);
    var holder = document.createElement('div');
    holder.appendChild(template.content.cloneNode(true));
    modal = holder.querySelector('[data-rynor-pmodal]');
    if (!modal) return;

    document.body.appendChild(modal);
    modalOpener = opener;
    placeModal();
    refreshModalCta();
    modal.classList.add('is-open');
    void modal.offsetWidth; /* start the fade from 0 */
    modal.classList.add('is-visible');

    var card = modal.querySelector('.rynor-pmodal__card');
    if (card) card.focus({ preventScroll: true });
  }

  function closeModal(instant) {
    if (!modal) return;
    var el = modal;
    modal = null;
    el.classList.remove('is-visible');
    if (instant || reduceMotion) { el.remove(); }
    else { window.setTimeout(function () { el.remove(); }, 200); }

    var back = modalOpener;
    modalOpener = null;
    if (instant) return;
    if (!back || !document.contains(back)) back = qs('[data-rynor-protect-learn]');
    if (back && isShown(back)) back.focus({ preventScroll: true });
  }

  function trapTab(e) {
    var card = modal && modal.querySelector('.rynor-pmodal__card');
    if (!card) return;
    var items = qsa('button, a[href], input, [tabindex]:not([tabindex="-1"])', card)
      .filter(function (el) { return !el.disabled && isShown(el); });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;
    if (e.shiftKey && (active === first || active === card)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
    else if (!card.contains(active)) { e.preventDefault(); first.focus(); }
  }

  /* ------------------------------------------------------------------ */
  /* footer height: keep the last upsell from hiding behind checkout    */
  /* ------------------------------------------------------------------ */
  function fitScrollArea() {
    var d = drawer();
    if (!d || !isShown(d)) return;
    var area = d.querySelector('.ajax-cart__scroll-area');
    var summary = d.querySelector('.js-cart-summary');
    if (!area) return;
    if (!summary || !summary.querySelector('[data-rynor-protect]') || !isShown(summary)) {
      area.style.removeProperty('padding-bottom'); /* back to the theme's own 96px */
      return;
    }
    var height = Math.ceil(summary.getBoundingClientRect().height);
    if (height > 0) area.style.setProperty('padding-bottom', (height + 14) + 'px', 'important');
  }

  /* ------------------------------------------------------------------ */
  /* wiring                                                             */
  /* ------------------------------------------------------------------ */
  function onRender() {
    renderQueued = false;
    var meta = readMeta();
    if (!meta) return;

    syncCountAndFreeShipping(meta);
    if (meta.visible < 1 || !meta.urgency) clearReserve(); /* empty cart, or pill switched off */
    if (qs('[data-rynor-urgency]')) startTicking(); else stopTicking();
    syncProtection(meta);
    if (meta.visible < 1) resetDeclinedForNextCart(meta);
    else declinedCleared = false;
    refreshModalCta();
    fitScrollArea();
  }

  function queueRender() {
    if (renderQueued) return;
    renderQueued = true;
    Promise.resolve().then(onRender);
  }

  var contentObserver = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var r = records[i];
      var t = r.target;
      if (r.type === 'childList' && t.classList && t.classList.contains('js-ajax-cart-content')) { queueRender(); return; }
      if (r.type === 'attributes' && t.matches && t.matches('.js-cart-form, .js-cart-empty')) { queueRender(); return; }
    }
  });

  function watch() {
    qsa('.js-ajax-cart-content').forEach(function (el) {
      if (el.__rynorWatched) return;
      el.__rynorWatched = true;
      contentObserver.observe(el, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    });

    var d = drawer();
    if (d && !d.__rynorWatched) {
      d.__rynorWatched = true;
      var wasOpen = drawerOpen();
      new MutationObserver(function () {
        var open = drawerOpen();
        if (open && !wasOpen) {
          var list = d.querySelector('.ajax-cart__scroll-area');
          if (list) list.scrollTop = 0;   /* v38: the cart always opens at the top */
          tick();
          syncProtection(readMeta());
          window.requestAnimationFrame(fitScrollArea);
        }
        if (!open && wasOpen) closeModal(true);
        wasOpen = open;
      }).observe(d, { attributes: true, attributeFilter: ['class'] });
    }
  }

  document.addEventListener('change', function (e) {
    var input = e.target && e.target.closest && e.target.closest('[data-rynor-protect-toggle]');
    if (input) onToggle(input);
  });

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;

    var learn = target.closest('[data-rynor-protect-learn]');
    if (learn) { e.preventDefault(); openModal(learn); return; }

    if (!modal || !modal.contains(target)) return;

    if (target.closest('[data-rynor-pmodal-close]')) { e.preventDefault(); closeModal(); return; }

    var cta = target.closest('[data-rynor-pmodal-cta]');
    if (cta) {
      e.preventDefault();
      if (cta.getAttribute('data-mode') === 'add') {
        var meta = readMeta();
        if (meta && meta.variant && meta.enabled && !busy) {
          qsa('[data-rynor-protect]').forEach(function (row) {
            row.classList.add('is-on');
            var input = row.querySelector('[data-rynor-protect-toggle]');
            if (input) input.checked = true;
          });
          setProtection(meta.variant, 1, false);
        }
      }
      closeModal();
    }
  });

  /* Escape closes the pop-up only – the theme closes the whole drawer on Escape keyup,
     so both key events are stopped while the pop-up is open */
  window.addEventListener('keydown', function (e) {
    if (!modal) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      e.stopPropagation();
      swallowEscKeyup = true;
      closeModal();
    } else if (e.key === 'Tab') {
      e.stopPropagation();
      trapTab(e);
    }
  }, true);

  window.addEventListener('keyup', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && (modal || swallowEscKeyup)) {
      e.stopPropagation();
      swallowEscKeyup = false;
    }
  }, true);

  window.addEventListener('resize', function () {
    placeModal();
    fitScrollArea();
  });

  /* ------------------------------------------------------------------ */
  /* iPhone: the cart list always keeps its own swipes (v38)            */
  /* ------------------------------------------------------------------ */
  /* When the list is already at its very top or bottom, iOS hands the next swipe to the
     page behind the drawer - that is what froze the list after swiping past the bottom
     of "Complete your outfit". Nudging the list 1px off the edge the moment a finger
     lands means the list can move both ways, so it keeps the swipe. (overscroll-behavior
     in component-slideouts.css does the same job on newer iPhones; this covers the rest.) */
  document.addEventListener('touchstart', function (e) {
    var t = e.target;
    var area = t && t.closest ? t.closest('#slideout-ajax-cart .ajax-cart__scroll-area') : null;
    if (!area || !drawerOpen()) return;
    var max = area.scrollHeight - area.clientHeight;
    if (max < 2) return;
    var top = area.scrollTop;
    if (top <= 0.5) area.scrollTop = 1;
    else if (top >= max - 0.5) area.scrollTop = max - 1;
  }, { capture: true, passive: true });

  function init() {
    watch();
    onRender();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.RynorCartExtras = { refresh: onRender };
})();
